<template>
  <div>
    <div v-if="userRole !== 'guest'" class="innerItem">
      <button type="button" class="btn btnFull btnPrimary" @click="save">{{locale.save}}</button>
    </div>
    <div class="innerItem">
      <!-- 공개/미공개 -->
      <div class="mb15">
        <div class="checkbox f_medium toCapitalize">
          <input type="checkbox" id="activeFloating" v-model="localSetting.active">
          <label for="activeFloating">{{locale.state_public}}</label>
        </div>
      </div>
      <!-- //공개/미공개 -->
      <!-- 메인페이지만 적용 -->
      <div class="mb30">
        <div class="checkbox f_medium">
          <input type="checkbox" id="floatingMainOnly" v-model="localSetting.mainOnly">
          <label for="floatingMainOnly">{{locale.floating_set_main_only}}</label>
        </div>
      </div>
      <!-- //메인페이지만 적용 -->
      <!-- 배너 기본 설정 -->
      <div class="mb30">
        <p class="groupLabel mb5">기본 설정</p>
        <div class="mb15">
          <p class="setLabel mb5">{{locale.floating_banner_size}}</p>
          <input type="text" class="input" v-model="localSetting.bannerStyle.size" @blur="emitSetting" />
          <div class="checkbox">
            <input type="checkbox" name="banner_size_axis" id="banner_size_axis_y" v-model="localSetting.bannerStyle.axisY" @change="emitSetting" />
            <label for="banner_size_axis_y">세로 사이즈 기준으로 변경</label>
          </div>
        </div>
        <div class="bannerPosition mb15">
          <div class="spot9">
            <div class="setLabel">{{ locale.position }}</div>
            <div class="box">
              <div
                v-for="(pos, index) in FLOATING_POS"
                :key="index"
                :class="{ radioItem: true, active: bannerPos === pos, disabled: !pos }">
                <input
                  type="radio"
                  name="banner_default_pos"
                  :id="`banner_default_pos_${index}`"
                  :value="pos"
                  :disabled="!pos"
                  v-model="bannerPos" />
                <label :for="`banner_default_pos_${index}`"></label>
              </div>
            </div>
          </div>
          <div class="bannerMargin">
            <div class="mb15">
              <p class="setLabel mb5">상하 여백</p>
              <input type="text" class="input" v-model="localSetting.bannerStyle.marginY" @blur="emitSetting" />
            </div>
            <div class="mb15">
              <p class="setLabel mb5">좌우 여백</p>
              <input type="text" class="input" v-model="localSetting.bannerStyle.marginX" @blur="emitSetting" />
            </div>
          </div>
        </div>
      </div>
      <!-- //배너 기본 설정 -->
       <!-- 배너 활성화 설정 -->
      <div class="mb30">
        <p class="groupLabel mb5">활성화 설정</p>
        <div class="mb15">
          <div class="checkbox">
            <input type="checkbox" name="banner_active_style_isactive" id="banner_active_style_isactive_y" v-model="localSetting.bannerActiveStyle.active" @change="emitSetting" />
            <label for="banner_active_style_isactive_y">{{ locale.use }}</label>
          </div>
        </div>
        <div v-if="localSetting.bannerActiveStyle.active">
          <div class="mb15">
            <p class="setLabel mb5">{{locale.floating_banner_size}}</p>
            <input type="text" class="input" v-model="localSetting.bannerActiveStyle.size" @blur="emitSetting" />
            <div class="checkbox">
              <input type="checkbox" name="banner_active_size_axis" id="banner_active_size_axis_y" v-model="localSetting.bannerActiveStyle.axisY" @change="emitSetting" />
              <label for="banner_active_size_axis_y">세로 사이즈 기준으로 변경</label>
            </div>
          </div>
          <div class="bannerPosition mb15">
            <div class="spot9">
              <div class="setLabel">{{ locale.position }}</div>
              <div class="box">
                <div
                  v-for="(pos, index) in FLOATING_POS"
                  :key="index"
                  :class="{ radioItem: true, active: bannerActivePos === pos, disabled: !pos }">
                  <input
                    type="radio"
                    name="banner_active_pos"
                    :id="`banner_active_pos_${index}`"
                    :value="pos"
                    :disabled="!pos"
                    v-model="bannerActivePos" />
                  <label :for="`banner_active_pos_${index}`"></label>
                </div>
              </div>
            </div>
            <div class="bannerMargin">
              <div class="mb15">
                <p class="setLabel mb5">상하 여백</p>
                <input type="text" class="input" v-model="localSetting.bannerActiveStyle.marginY" @blur="emitSetting" />
              </div>
              <div class="mb15">
                <p class="setLabel mb5">좌우 여백</p>
                <input type="text" class="input" v-model="localSetting.bannerActiveStyle.marginX" @blur="emitSetting" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- //배너 활성화 설정 -->
    </div>
  </div>
</template>

<script>
import {
  createDefaultBannerStyle,
  createDefaultBannerActiveStyle
} from '@/constants/floating'

export default {
  name: 'SetFloatingItem',
  props: [
    'locale',
    'setting'
  ],
  computed: {
    userRole () {
      return this.$store.getters['authentication/getAuthInfo'].userRole
    },
    bannerPos: {
      get () {
        return this.getPosCode(this.localSetting.bannerStyle)
      },
      set (pos) {
        this.applyPosCode(this.localSetting.bannerStyle, pos)
        this.emitSetting()
      }
    },

    bannerActivePos: {
      get () {
        return this.getPosCode(this.localSetting.bannerActiveStyle)
      },
      set (pos) {
        this.applyPosCode(this.localSetting.bannerActiveStyle, pos)
        this.emitSetting()
      }
    }
  },
  watch: {
    setting: {
      immediate: true,
      deep: true,
      handler (v) {
        this.localSetting = {
          active: v?.active ?? false,
          mainOnly: v?.mainOnly ?? false,
          bannerStyle: {
            ...createDefaultBannerStyle(),
            ...(v?.bannerStyle || {})
          },
          bannerActiveStyle: {
            ...createDefaultBannerActiveStyle(),
            ...(v?.bannerActiveStyle || {})
          }
        }
      }
    }
  },
  data () {
    return {
      FLOATING_POS: [
        'tl', '', 'tr',
        '', '', '',
        'bl', '', 'br'
      ],
      localSetting: {
        active: false,
        mainOnly: false,
        bannerStyle: createDefaultBannerStyle(),
        bannerActiveStyle: createDefaultBannerActiveStyle()
      }
    }
  },
  methods: {
    getPosCode(style) {
      const x = style?.positionX
      const y = style?.positionY

      if (x === 'left' && y === 'top') return 'tl'
      if (x === 'right' && y === 'top') return 'tr'
      if (x === 'left' && y === 'bottom') return 'bl'
      if (x === 'right' && y === 'bottom') return 'br'

      return ''
    },

    applyPosCode(style, pos) {
      if (!style) return
      switch (pos) {
        case 'tl':
          style.positionX = 'left'
          style.positionY = 'top'
          break
        case 'tr':
          style.positionX = 'right'
          style.positionY = 'top'
          break
        case 'bl':
          style.positionX = 'left'
          style.positionY = 'bottom'
          break
        case 'br':
          style.positionX = 'right'
          style.positionY = 'bottom'
          break
        default:
          return
      }
    },
    emitSetting () {
      const updateData = {
        active: this.localSetting.active,
        mainOnly: this.localSetting.mainOnly,
        bannerStyle: { ...this.localSetting.bannerStyle },
        bannerActiveStyle: { ...this.localSetting.bannerActiveStyle }
      }
      this.$emit('updateSetting', updateData)
    },
    save: function () {
      this.$emit('save')
    }
  }
}
</script>

<style lang="scss" scoped>
.bannerPosition {
  display: flex;
  align-items: flex-start;
  gap: 15px;
}
.bannerMargin {
  flex: 1;
}
.spot9 {
  flex: 1;
  max-width: 90px;
  .box {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
    gap: 2px;
  }
  .radioItem {
    label {
      display: block;
      height: 30px;
    }
    border-radius: 4px;
    border: 1px solid $color-lgrey2;
    background-color: $color-white;
    &.active {
      border-color: $color-dark;
      background-color: $color-dark;
    }
    &.disabled {
      opacity: 0.5;
      background-color: $bg-default;
    }
  }
}
</style>
